// Components/ui
import { useTranslationContext } from '../../../../../../../context/TranslationContext';
import { Warning } from './components';
import { Box, Grid } from '@mui/material';

type WarningsDisplayProps = {
  warnings: string[];
  existingContactId?: string | null;
};

const WarningsDisplay = ({ warnings, existingContactId }: WarningsDisplayProps) => {
  const t = useTranslationContext();

  return (
    <Box>
      <Grid container>
        {warnings?.map((warning, i) => (
          <Warning
            key={i}
            code={warning}
            text={t(`contactAddressError.${warning}`)}
            existingContactId={existingContactId}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default WarningsDisplay;
